export class TblLeadChannel
{
    refNo:number
    channelName:string
}